import ACTIONS from "../actions/types";
import concat from "lodash/concat";
import { sortByDateDesc } from "../../utils/helpers";

const initialState = {
  isEditContarctMode: false,
  isFetchingOrgContarcts: true,
  isFetchingContractLogs: false,
  isFetchingSelectedContarctInfo: true,
  isFetchingSelectedContarctDevices: true,
  orgAllContracts: [],
  SelectedContarctDevices: [],
  contractpackages: [],
  contractLogs: [],

  selectedContact: {},
};

const contractsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.CONTRACTS.FETCH_CONTRACT_PACKAGES:
      return Object.assign({}, state, { contractpackages: [...payload] });

    case ACTIONS.CONTRACTS.FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_START:
      return Object.assign({}, state, { isFetchingOrgContarcts: true });

    case ACTIONS.CONTRACTS.FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetchingOrgContarcts: false,
        orgAllContracts: [...sortByDateDesc(payload, "created_at")],
      });

    // case ACTIONS.CONTRACTS.FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_FAILURE:
    //   return Object.assign({}, state, {
    //     isFetchingOrgContarcts: false,
    //     orgAllContracts: [],
    //   });

    case ACTIONS.CONTRACTS.FETCH_SELECTED_CONTRACT_INFO_START:
      return Object.assign({}, state, { isFetchingSelectedContarctInfo: true });

    case ACTIONS.CONTRACTS.SET_SELECTED_CONTRACTS:
      return Object.assign({}, state, {
        isFetchingSelectedContarctInfo: false,
        selectedContact: payload,
      });

    case ACTIONS.CONTRACTS.FETCH_ORGANIZATIONS_ALL_CONTRACTS_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetchingSelectedContarctInfo: true,
        selectedContact: {},
      });

    case ACTIONS.CONTRACTS.FETCH_SELECTED_CONTRACT_DEVICES_START:
      return Object.assign({}, state, {
        isFetchingSelectedContarctDevices: true,
      });

    case ACTIONS.CONTRACTS.SET_SELECTED_CONTRACT_DEVICES:
      return Object.assign({}, state, {
        isFetchingSelectedContarctDevices: false,
        SelectedContarctDevices: [...sortByDateDesc(payload, "created_at")],
      });

    case ACTIONS.CONTRACTS.FETCH_SELECTED_CONTRACT_DEVICES_FAILURE:
      return Object.assign({}, state, {
        isFetchingSelectedContarctDevices: true,
        SelectedContarctDevices: [],
      });
    case ACTIONS.CONTRACTS.REMOVE_DEVICE_FROM_CONTRACT_START:
      return Object.assign({}, state, {
        isFetchingSelectedContarctDevices: true,
      });
    case ACTIONS.CONTRACTS.REMOVE_DEVICE_FROM_CONTRACT:
      return Object.assign({}, state, {
        isFetchingSelectedContarctDevices: false,
        SelectedContarctDevices: [
          ...sortByDateDesc(
            state.SelectedContarctDevices.filter((d) => d._id !== payload._id),
            "created_at"
          ),
        ],
      });

    case ACTIONS.CONTRACTS.ASSIGN_DEVICES_TO_CONTRACT_START:
      return Object.assign({}, state, {
        isFetchingSelectedContarctDevices: true,
      });

    case ACTIONS.CONTRACTS.ASSIGN_DEVICES_TO_CONTRACT:
      // let _selectedContarctDevices = concat(
      //   state.SelectedContarctDevices,
      //   payload
      // );
      return Object.assign({}, state, {
        isFetchingSelectedContarctDevices: false,
        SelectedContarctDevices: [
          ...sortByDateDesc(
            concat(state.SelectedContarctDevices, payload),
            "created_at"
          ),
        ],
      });

    case ACTIONS.CONTRACTS.ASSIGN_DEVICES_TO_CONTRACT_FALURE:
      return Object.assign({}, state, {
        isFetchingSelectedContarctDevices: true,
      });

    case ACTIONS.CONTRACTS.REMOVE_DEVICE_FROM_CONTRACT_FALURE:
      return Object.assign({}, state, {
        isFetchingSelectedContarctDevices: true,
      });

    case ACTIONS.CONTRACTS.TOGGLE_IS_EDIT_CONTRACT_MODE:
      return Object.assign({}, state, {
        isEditContarctMode: !state.isEditContarctMode,
      });

    case ACTIONS.CONTRACTS.CLEAR_SELECTED_CONTRACT:
      return Object.assign({}, state, {
        isEditContarctMode: false,
        isFetchingOrgContarcts: true,
        isFetchingSelectedContarctInfo: true,
        isFetchingSelectedContarctDevices: true,
        orgAllContracts: [],
        SelectedContarctDevices: [],
        selectedContact: {},
      });

    case ACTIONS.CONTRACTS.DELETE_CONTRACT_START:
      return Object.assign({}, state, {
        isFetchingOrgContarcts: true,
      });
    case ACTIONS.CONTRACTS.DELETE_CONTRACT:
      return Object.assign({}, state, {
        isFetchingOrgContarcts: false,
        orgAllContracts: [
          ...sortByDateDesc(
            state.orgAllContracts.filter((d) => d._id !== payload._id),
            "created_at"
          ),
        ],
      });
    case ACTIONS.CONTRACTS.DELETE_CONTRACT_FALURE:
      return Object.assign({}, state, {
        isFetchingOrgContarcts: true,
      });

    case ACTIONS.CONTRACTS.SUBMIT_EDIT_CONTRACT_START:
      return Object.assign({}, state, {
        isFetchingSelectedContarctInfo: true,
      });
    case ACTIONS.CONTRACTS.SUBMIT_EDIT_CONTRACT:
      return Object.assign({}, state, {
        isFetchingSelectedContarctInfo: false,
        selectedContact: payload,
      });
    case ACTIONS.CONTRACTS.SUBMIT_EDIT_CONTRACT_FALURE:
      return Object.assign({}, state, {
        isFetchingSelectedContarctInfo: true,
      });

    case ACTIONS.CONTRACTS.ADD_CONTRACT_START:
      return Object.assign({}, state, {
        isFetchingOrgContarcts: true,
      });
    case ACTIONS.CONTRACTS.ADD_CONTRACT: {
      return Object.assign({}, state, {
        isFetchingOrgContarcts: false,
        orgAllContracts: [
          ...sortByDateDesc([...state.orgAllContracts, payload], "created_at"),
        ],
      });
    }
    case ACTIONS.CONTRACTS.ADD_CONTRACT_FALURE:
      return Object.assign({}, state, {
        isFetchingOrgContarcts: false,
        addContractMsg: payload,
      });

    case ACTIONS.CONTRACTS.FETCH_CONTRACTS_LOGS_LIST_START:
      return Object.assign({}, state, {
        isFetchingContractLogs: true,
        contractLogs: [],
      });
    case ACTIONS.CONTRACTS.FETCH_CONTRACTS_LOGS_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetchingContractLogs: false,
        contractLogs: [...payload],
      });
    case ACTIONS.CONTRACTS.FETCH_CONTRACTS_LOGS_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetchingContractLogs: true,
        contractLogs: [],
      });

    case ACTIONS.LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default contractsReducer;
